export default __webpack_public_path__ + "static/media/Like.e98057de.svg";